import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 md:mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}